import { SettingsSection } from './SettingsSection';
import { MyStuffTranslationKeys, SettingsTranslationKeys } from '../../../api/models/TranslationKeys';
import { SettingsButton } from '../components/SettingsButton';
import { PinChangeDialog } from '../components/PinChangeDialog';

export class PincodeSection extends SettingsSection {
  /**
   * @param {Backend} backend
   */
  constructor(backend) {
    super(backend, backend.translations.forKey(SettingsTranslationKeys.settings_title_pincode));
  }

  addControls(list) {
    super.addControls(list);
    // list.items.childList.a({
    //   type: SettingsButton,
    //   data: {
    //     topLine: this.backend.translations.forKey(MyStuffTranslationKeys.mystuff_change_adult_pincode),
    //     bottomLine: '●●●●',
    //     action: () => {
    //       list.fireAncestors('$openDialog', {
    //         type: PinChangeDialog,
    //         backend: this.backend,
    //         adult: true,
    //       });
    //     },
    //   },
    //   passSignals: {
    //     onActivate: true,
    //   },
    // });
    list.items.childList.a({
      type: SettingsButton,
      data: {
        topLine: this.backend.translations.forKey(MyStuffTranslationKeys.mystuff_change_vod_pincode),
        bottomLine: '●●●●',
        action: () => {
          list.fireAncestors('$openDialog', {
            type: PinChangeDialog,
            backend: this.backend,
            adult: false,
          });
        },
      },
      passSignals: {
        onActivate: true,
      },
    });
  }
}
